import { baseSiteEndPoint, buildHeaders, urlFilters, getSellerID } from "./common";
import { authorizedFetch } from "./login";

export const apiAccountsList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiAccountDetails = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiMccCodes = async () => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/mcc/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data.items || data.results || (Array.isArray(data) ? data : []);
  } catch (error) {
    throw error;
  }
};

export const apiAccountDocumentUpload = async (accountId, file, documentType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('document_type', documentType);

  const response = await authorizedFetch(
    `${baseSiteEndPoint}/unified/accounts/sellers/${accountId}/documents/upload/`,
    {
      method: "POST",
      headers: buildHeaders("", null),
      body: formData,
    }
  );
  return response.json();
};

export const apiAccountEdit = async (id, dataJSON) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${id}/`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify(dataJSON),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiForceUpdateSeller = async (accountId) => {
  const response = await authorizedFetch(
    `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${accountId}/force-update-seller/`,
    {
      method: "POST",
      headers: buildHeaders(),
    }
  );
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};

export const apiForceRegisterSeller = async (accountId) => {
  const response = await authorizedFetch(
    `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${accountId}/force-register-seller/`,
    {
      method: "POST",
      headers: buildHeaders(),
    }
  );
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};

export const apiForceUpdateDeltapagSeller = async (accountId) => {
  const response = await authorizedFetch(
    `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${accountId}/force-update-deltapag-seller/`,
    {
      method: "POST",
      headers: buildHeaders(),
    }
  );
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};

export const apiForceRegisterDeltapagSeller = async (accountId) => {
  const response = await authorizedFetch(
    `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${accountId}/force-register-deltapag-seller/`,
    {
      method: "POST",
      headers: buildHeaders(),
    }
  );
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};

const accountAcquirerPriorityUrl = (accountId) =>
  `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${accountId}/acquirer-priority/`;

export const apiAccountAcquirerPriority = async (accountId) => {
  const response = await authorizedFetch(accountAcquirerPriorityUrl(accountId), {
    method: "GET",
    headers: buildHeaders(),
  });
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};

export const apiUpdateAccountAcquirerPriority = async (accountId, payload) => {
  const response = await authorizedFetch(accountAcquirerPriorityUrl(accountId), {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};